module.exports = __webpack_public_path__ + "media/images/features/draft/heading-voices-66c3e2ad72b6107c1a8af64186c0e1fc.svg";